// extracted by mini-css-extract-plugin
module.exports = {"login_box":"_3L9dCgufxdYygr8rxkqpvO","page":"_3uUIJBqavu38SrA4NvDCH4","neon":"KV9ClvfWwDAFezyl4SmjC","check":"_2Kg0RreWacOQuHE8ghfONo"};